import script from "./ContentBlockBase.vue?vue&type=script&lang=js"
export * from "./ContentBlockBase.vue?vue&type=script&lang=js"

import "./ContentBlockBase.vue?vue&type=style&index=0&id=361ee741&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/components/ContentCreator/ContentBlockBase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "361ee741"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('361ee741', __exports__)) {
    api.reload('361ee741', __exports__)
  }
  
}


export default __exports__